import Vue from "vue";
import Vuex from "vuex";

import alert from "./module.alert";
import authentication from "./module.authentication";
import notifications from "./module.notifications";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    alert,
    authentication,
    notifications
  },
  state: {},
  mutations: {},
  actions: {}
});

export default store;
